<template>
    <div>
        <b-row>
            <b-col cols="12" md="12">
                <app-form-input label="Nombre" v-model="filters.name" @keyup.enter="filter" />
            </b-col>
            <b-col cols="12" md="6">
                <label for="datepicker">Fecha Inicio</label>
                <b-form-datepicker id="datepicker" v-model="filters.from" class="mb-2"></b-form-datepicker>
            </b-col>
            <b-col cols="12" md="6">
                <label for="datepicker">Fecha Fin</label>
                <b-form-datepicker id="datepicker" v-model="filters.to" class="mb-2"></b-form-datepicker>
            </b-col>
            <b-col class="right-spaced mt-4">
                <b-btn variant="primary" title="filtrar" size="sm" @click="filter">
                    <i class="fa fa-filter"></i>
                </b-btn>
                <b-btn variant="secondary" title="limpiar" size="sm" @click="clear">
                    <i class="fa fa-times"></i>
                </b-btn>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    data: () => ({
        filters: {
            name: '',
            from: '',
            to: '',
        },
    }),
    methods: {
        filter() {
            this.$emit('filters', this.filters)
        },
        clear() {
            Object.keys(this.filters).map((key) => (this.filters[key] = ''))
            this.$emit('clear')
        },
    },
}
</script>
